module.exports = __webpack_public_path__ + "static/media/icon_tag.a555a89f.svg";